import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import orgDataService from "services/orgDataService";
import { VehicleListItem } from "vehicles/models";
import vehiclesService from "services/vehiclesService";
import MDButton from "components/MDButton";
import { useContext } from "react";
import { AuthContext } from "common/AuthProvider";
import moment from "moment";
import {tripData, setTrip, getTrip} from "store/tripSlice";
import {useSelector, useDispatch} from "react-redux";
import tripService from "services/tripService";

const TripDispatch = () => {
  const dispatch = useDispatch();
  const trip = useSelector(tripData);
  const [vehicles, setVehicles] = useState<VehicleListItem[]>([]);
  const [drivers, setDrivers] = useState([]);
  const [dispatcherNotes, setDispatcherNotes] = useState("");
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!trip?.hub) return;
    vehiclesService.getVehiclesByHub(trip?.hub?.id).then((_vehicles) => {
      if (trip.vehicle?.id) {
        var vehicleFound = _vehicles.filter((f) => f.id == trip.vehicle?.id);
        if (vehicleFound.length === 0) {
          _vehicles.unshift(trip.vehicle);
        }
      }
      setVehicles(_vehicles);
    });

    orgDataService.getDrivers(trip?.hub?.id).then((_drivers) => {
      if (trip.driver?.id) {
        var driverFound = _drivers.filter((d) => d.id == trip.driver?.id);
        if (driverFound.length === 0) {
          _drivers.unshift(trip.driver);
        }
      }
      setDrivers(_drivers);
    });
  }, [trip?.hub]);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    dispatch(setTrip({ ...trip, [name]: value }));
  };

  const addDispatcherNotes = async () => {
    if (!dispatcherNotes?.trim()) return;
    const notes = `${trip.dispatcherNotes ?? ""}\n[${moment().format("MM/DD/YYYY HH:mm")} ${
      user?.email
    }] ${dispatcherNotes}`;
    // Update Redux immediately so the textarea shows the appended note while the save is in flight.
    dispatch(setTrip({ ...trip, dispatcherNotes: notes }));
    setDispatcherNotes("");
    // Persist to backend so the note survives refresh -- the parent's Save button isn't required.
    await tripService.updateDetails({
      id: trip.id,
      crew: trip.crew?.map((c) => c.name),
      driverId: trip?.driver?.id,
      vehicleId: trip?.vehicle?.id,
      dispatcherNotes: notes,
      isAwaitingDispatch: trip?.isAwaitingDispatch,
      isMpv: trip?.isMpv,
      isWaitingResponse: trip?.isWaitingResponse,
      isAmended: trip?.isAmended,
    });
    dispatch(getTrip(trip.id));
  };
  return (
    <>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel>Driver</InputLabel>
          <Select
            name="driverId"
            onChange={(e) => dispatch(setTrip({ ...trip, driver: { id: +e.target.value } }))}
            value={trip?.driver?.id || ""}
            label="Driver"
          >
            {drivers &&
              drivers.map((d, index) => {
                return (
                  <MenuItem key={index} value={d.id}>
                    {`${d.name} ${d.cellPhone ? d.cellPhone + "(C)":""} ${d.homePhone1 ? d.homePhone1 + "(H1)": ""} ${d.homePhone2 ? d.homePhone2 + "(H2)": ""}`}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel>Vehicle</InputLabel>
          <Select
            name="vehicleId"
            onChange={(e) => dispatch(setTrip({ ...trip, vehicle: { id: +e.target.value } }))}
            value={trip?.vehicle?.id || ""}
            label="Vehicle"
          >
            {vehicles &&
              vehicles.map((v, index) => {
                return (
                  <MenuItem key={index} value={v.id}>
                    {`${v.unitNumber} - ${v.description} - ${v.plateNumber}`}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4} lg={3}>
        <FormControlLabel
          control={<Checkbox name="isAwaitingDispatch" onChange={handleChange} checked={!!trip?.isAwaitingDispatch} />}
          label="Is Awaiting Dispatch"
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <FormControlLabel
          control={<Checkbox name="isWaitingResponse" onChange={handleChange} checked={!!trip?.isWaitingResponse} />}
          label="Is Waiting Response"
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <FormControlLabel
          control={<Checkbox name="isAmended" onChange={handleChange} checked={!!trip?.isAmended} />}
          label="Is Amended"
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <FormControlLabel
          control={<Checkbox name="isMpv" onChange={handleChange} checked={!!trip?.isMpv} />}
          label="Is MPV"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          inputProps={{ readOnly: true }}
          name="dispatcherNotes"
          onChange={handleChange}
          value={trip?.dispatcherNotes || ""}
          label="Dispatcher Notes"
          fullWidth
          multiline
          rows={14}
        />
        <Grid container sx={{ mt: 1 }} spacing={1} alignItems="center">
          <Grid item xs={12} sm={10}>
            <TextField
              fullWidth
              name="addDispatcherNotes"
              value={dispatcherNotes}
              onChange={(e) => setDispatcherNotes(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <MDButton
              type="button"
              onClick={addDispatcherNotes}
              variant="contained"
              color="secondary"
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              Add Notes
            </MDButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default TripDispatch;
